import Config from '@/config'
import { logger } from '@/lib/logger'
import type { ApisauceInstance } from 'apisauce'
import { create } from 'apisauce'
import { authRequestInterceptor } from './interceptors/auth'
import type {
	DemoAccountResponse,
	LoginCodeRequest,
	LoginCodeResponse,
	LoginExchangeRequest,
	LoginExchangeResponse,
} from './types/AuthApi'

export class AuthApi {
	_apiConfig: ApisauceInstance

	constructor() {
		this._apiConfig = create({
			baseURL: Config.AUTH_API_URL_BASE,
			timeout: 10000,
		})

		this._apiConfig.axiosInstance.interceptors.request.use(authRequestInterceptor)
	}

	fetchDemoAccountToken() {
		return this._apiConfig
			.post('/login/demo-account')
			.then((response) => response.data as DemoAccountResponse)
			.catch((error) => {
				logger.error(new Error('failed_to_get_demo_token', { cause: error }))
				return null
			})
	}

	sendLoginCodeToEmail(email: string) {
		return this._apiConfig
			.post('/login/codes/send', { email } as LoginCodeRequest)
			.then((response) => response.data as LoginCodeResponse)
			.catch((error) => {
				logger.error(new Error('failed_to_send_login_code'), { cause: error })
				return { isRateLimited: false, isCodeSent: false } as LoginCodeResponse
			})
	}

	exchangeCodeForAuthToken(request: LoginExchangeRequest) {
		return this._apiConfig.post('/login/codes/exchange', request).then((response) => {
			if (!response.ok) {
				return {
					token: undefined,
					isValid: false,
				} as LoginExchangeResponse
			}

			return {
				// @ts-ignore
				token: response.data?.token,
				isValid: true,
			} as LoginExchangeResponse
		})
	}
}

export const authApi = new AuthApi()
